import { OrderWizardService } from "../../../_service/order-wizard.service";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: 'order-purchase-summary-table',
    imports: [CommonModule, TranslateModule],
    templateUrl: './order-purchase-summary-table.component.html',
    styleUrls: ['./order-purchase-summary-table.component.scss']
})
export class OrderPurchaseSummaryTableComponent implements OnInit, OnDestroy {

    constructor(
        public _orderWizardService: OrderWizardService
    ) {
    }

    ngOnInit(): void {

    }

    ngOnDestroy(): void {
  
    }
}